var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleExclamationSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.777,
    height: 18.777,
    viewBox: "0 0 18.777 18.777",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "circle-exclamation-solid",
    d: "M9.388,18.777A9.388,9.388,0,1,0,0,9.388,9.388,9.388,0,0,0,9.388,18.777Zm0-14.082a.878.878,0,0,1,.88.88V9.682a.88.88,0,0,1-1.76,0V5.574A.878.878,0,0,1,9.388,4.694Zm1.174,8.215a1.174,1.174,0,1,1-1.174-1.174A1.172,1.172,0,0,1,10.562,12.909Z",
    fill: "#be311e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleExclamationSolid);
export default __webpack_public_path__ + "static/media/circle-exclamation-solid.fd4fa93835db59183db5b321671c4e86.svg";
export { ForwardRef as ReactComponent };